import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const URLImportFile = URL + 'hemodialysis/api/'

export default {
  namespaced: true,
  state: {
    listService: { 'results': [] },
    service: {},
    defaultService: {
      id: null,
      person: null,
      date_hemodialysis: null
    }
  },
  mutations: {
    setListPerson (state, payload) {
      state.listService = payload
    },
    setService (state, payload) {
      // Vue.set(state.listPerson.results, payload.index, payload.data)
      state.service = payload
      state.service.date_hemodialysis = state.service.date_hemodialysis.substr(0, 10)
    },
    setDefaultService (state) {
      // Vue.set(state.listPerson.results, payload.index, payload.data)
      state.service = Object.assign({}, state.defaultService)
    }
  },
  actions: {
    fetchListService ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisFetchListService'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        params['person_id'] = payload.person_id
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        let _url = URLImportFile + 'service/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchService ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisFetchService'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URLImportFile + 'service/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setService', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertService ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisInsertService_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        data.append('person', payload.person)
        data.append('date_hemodialysis', payload.date_hemodialysis + 'T00:00:00')
        let _url, method
        if (payload.id === null) {
          _url = URLImportFile + 'service/'
          method = 'post'
        } else {
          _url = URLImportFile + 'service/' + payload.id + '/'
          method = 'put'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setService', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteService ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisDeleteService_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URLImportFile + 'service/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            commit('setService', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    listService (state) {
      return state.listService
    },
    service (state) {
      return state.service
    }
  }
}
